
































































import { Component, Vue, Prop } from 'vue-property-decorator';
import commonService from '@/services/common-services';
import { APP_CONFIG } from '@/config/app-config';

import { DepositModel } from '@/models/deposit';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class AmountDetailDeposit extends Vue {
    @Prop({default: null})
    private deposit!: DepositModel;

    get payment() {
        return this.deposit.payment > 0 ? formatNumber(this.deposit.payment, '0,0') + '' : '0';
    }

    private shippingMethodDisplay(id) {
        if (this.shippingMethod) {
            const ret = this.shippingMethod.find(c => c.ID === id) || {ID: 0, Name: 'Tiêu chuẩn'};
            return ret.Name;
        }
        return 'Tiêu chuẩn';
    }

    get shippingMethod() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].shippingMethod;
    }

    private async getShippingMethod() {
        const result = await commonService.getShippingMethod();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_SHIPPINGMETHOD', result.data.data);
        }
    }

    private async created() {
        if (!this.shippingMethod) {
            await this.getShippingMethod();
        }
    }
}
